module.exports = __webpack_public_path__ + "22c8fb0edd495eb1476321a6f80a33d7.svg";